import styled from 'styled-components';
import theme from 'common/theme'
const pad = 10
export const ConfiguredTooltipContainer = styled.div`

  font-size: .8em;
  position: fixed;
  left: 0;
  top: 0;
  display: none;
  pointer-events: none;
  z-index: 9999;
  
  &.is-visible {
    display: block;
  }

  [data-id="tooltip-sizer"] {
    position: relative;
 
  }
  
  .title {
    font-size: 1.1em;
    padding-bottom: ${pad /2}px;
    margin-bottom: ${pad /2}px;
    border-bottom: 1px solid ${theme.colors.border.main};
    font-weight: 600;

    .date-range {
      font-weight: 500;
      color: ${theme.colors.label};
      font-size: .9em;
      padding-top: .25em;
    }

  }

  .txt-md {
    font-size: .9em;
  }

    .txt-sm {
    font-size: .8em;
  }

  .tooltip-content {  
    padding: ${pad}px;
    background: white;
    border-radius: 5px;
    left: 0;
    top: 0;
    min-width: 50px;
    box-shadow: 0px 2px 6px rgba(0,0,0,0.2);

    .tooltip-items.grid {
      gap: ${pad / 2}px;
    }
  }
  
  .tooltip-arrow {
    position: absolute;
    width: ${pad}px;
    height: ${pad}px;
    background: white;
  }
`;
